const o = [];
export {
  o as default
};
//# sourceMappingURL=ronin-doodipals-doodinomics.json.js.map
